<template>
  <c-card>
    <loader v-show="$store.state.pettycash.loading" />
    <c-card-header v-show="header">
      <c-card-title>
        <strong>Petty Cash</strong>
      </c-card-title>
    </c-card-header>
    <c-card-body>
      <div>
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            placeholder="kettikkan untuk mencari kemudian enter"
            v-model="keyword"
            @keyup="search"
          />
        </div>
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th>Tanggal</th>
              <th>Penjelasan Transaksi</th>
              <th>COA Code</th>
              <th>COA</th>
              <th>Keterangan</th>
              <th>Debit</th>
              <th>Kredit</th>
              <th>Saldo</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(d, k) in $store.state.pettycash.cash_history.data"
              :key="k"
            >
              <td>{{ d.created_at | dateFormat }}</td>
              <td>
                {{ d.description }}
              </td>
              <td>{{ d.coa_code }}</td>
              <td>{{ d.coa_name }}</td>
              <td>{{ d.notes }}</td>
              <td class="right">{{ d.debit | thousandSeparator }}</td>
              <td class="right">{{ d.credit | thousandSeparator }}</td>
              <td class="right">{{ d.balance | thousandSeparator }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </c-card-body>
    <c-card-footer>
      <div class="row">
        <div class="col-md-4">
          <button class="btn btn-success" @click="exportExcel">
            Export Excel
          </button>
        </div>
        <div class="col-md-8">
          <paginator
            :paginator="$store.state.pettycash.cash_history.paginate"
            @change="changePage"
          />
        </div>
      </div>
    </c-card-footer>
  </c-card>
</template>
<script>
import Loader from '../../../components/Loader.vue';
import Paginator from '../../../components/Paginator.vue';
import { HTTPExport } from '../../../lib/httplib';
export default {
  props: ['header'],
  data () {
    return {
      keyword: ''
    }
  },
  components: { Loader, Paginator },
  created () {
    this.history(1);
  },
  methods: {
    history (page) {
      this.$store.dispatch('pettycash_cash_history', { page: page, q: this.keyword });
    },
    changePage (p) {
      this.history(p)
    },
    exportExcel () {
      this.$store.state.pettycash.loading = true
      HTTPExport.get("/api/v1/petty-cash-transaction/export/excel").then((res) => {
        const data = res.data.data;
        window.open(data, '_blank');
        this.$store.state.pettycash.loading = false
      }).catch(() => {
        this.$store.state.pettycash.loading = false
      });
    },
    search (e) {
      if (e.keyCode == 13) {
        this.history(1);
      }
    },
  },
};
</script>